import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { message } from 'ant-design-vue'
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/reset.css'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import App from './App.vue'
import router from './router'
import './styles/global.scss'

// 全局指令
import { permissionDirective } from './directives'
// 全局组件
import ModuleLayout from './components/ModuleLayout.vue'

const app = createApp(App)

app.use(createPinia())
app.use(router)
app.use(Antd)
app.use(ElementPlus)

// 注册全局指令
app.directive('permission', permissionDirective)

// 注册全局组件
app.component('ModuleLayout', ModuleLayout)

// ════════════════════════════════════════
// 🛡️ 全局错误边界（企业级错误处理）
// ════════════════════════════════════════

/**
 * Vue 组件错误处理器
 * 捕获所有未处理的组件异常，防止白屏崩溃
 */
app.config.errorHandler = (err, instance, info) => {
  // 开发环境输出详细日志（err 置首，保证 Error 以可展开形式完整展示堆栈）
  if (import.meta.env.DEV) {
    console.error('[Vue Error Boundary]', err, {
      component: instance?.$options?.name || 'Unknown',
      hook: info,
    })
  }

  // 生产环境优雅降级：显示用户友好提示
  const errorMsg = err instanceof Error ? err.message : '未知错误'

  // 避免重复提示相同错误（与已记录的全局标记比对，而非字面量）
  const lastError = (globalThis as { _lastErrorMessage?: string | null })._lastErrorMessage
  if (lastError !== errorMsg) {
    ;(globalThis as { _lastErrorMessage?: string | null })._lastErrorMessage = errorMsg
    message.error(`页面异常: ${errorMsg}`, 5)

    // 3秒后清除防重复标记
    setTimeout(() => {
      ;(globalThis as { _lastErrorMessage?: string | null })._lastErrorMessage = null
    }, 3000)
  }

  // 上报错误到监控服务（TODO: 对接 Sentry/自建监控）
  // errorReporter.captureException(err, { component: instance?.$options?.name, info })
}

/**
 * 未处理 Promise 拒绝监听器
 * 捕获异步操作中的未处理异常（如 API 500 错误）
 */
window.addEventListener('unhandledrejection', (event) => {
  const reason = event.reason

  // 网络错误或API错误，不阻塞用户操作
  if (reason instanceof Error) {
    // 开发环境详细输出
    if (import.meta.env.DEV) {
      console.warn('[Unhandled Rejection]', reason.message, reason.stack)
    }

    // 阻止默认行为（控制台红色错误）
    event.preventDefault()

    // 仅在非开发环境显示提示（避免干扰调试）
    if (!import.meta.env.DEV) {
      message.warning(`后台请求异常: ${reason.message}`, 3)
    }
  }
})

app.mount('#app')
